module.exports = __webpack_public_path__ + "h5/img/close.2e882cf1.gif";